import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { PriceList } from "@/app/services/generated/pricelistService";
import { priceListService } from "@/app/services/generated/pricelistService";

export interface IHasPriceListsCache {
  priceLists: PriceListsCache;
}

// Singleton cache store
const priceListsCacheStore = new EntityCacheStore<PriceList>(
  EnumCacheEntityType.priceList,
  async () => priceListService.getAllPriceLists()
);

// Ephemeral reader
export default class PriceListsCache extends EntityWithGuidKeyCache<PriceList> {
  constructor() {
    super(priceListsCacheStore, (x) => x.id);
  }
}
